import React, { useState } from "react";
import "./infra.css"; // Updated CSS file
import Header from "../../commons/header/header";
import Footer from "../../commons/footer/footer";
import image1 from "../../../../src/assests/images/background-3.jpg";
import f1 from "../../../assests/images/f1.jpeg";
import f10 from "../../../assests/images/f10.jpeg";
import f8 from "../../../assests/images/f8.jpeg";
import f5 from "../../../assests/images/f5.jpeg";
import f9 from "../../../assests/images/f9.jpeg";
import f11 from "../../../assests/images/f11.jpeg";
import f14 from "../../../assests/images/f14.jpeg";
import f15 from "../../../assests/images/f15.jpeg";
import f16 from "../../../assests/images/f16.jpeg";



// Sample data with categories
const images = [
  { src: f14, heading: "Library Main", category: "LIBRARY" },
  { src: f15, heading: "Hostel", category: "HOSTEL" },
  { src: f11, heading: "Bus", category: "TRANSPORT" },
  { src: f5, heading: "Parking", category: "TRANSPORT" },
  { src: f9, heading: "Parking", category: "TRANSPORT" },
  { src: f16, heading: "Gym", category: "GYMNASIUM" },
  { src: f1, heading: "Dining Hall", category: "MESS" },
  { src: f10, heading: "Temple", category: "TEMPLE" },
  { src: f8, heading: "Temple", category: "TEMPLE" },
];

const tabs = [
  "LIBRARY",
  "HOSTEL",
  "TRANSPORT",
  "YOGA CENTRE",
  "GYMNASIUM",
  "MESS",
  "TEMPLE",
];

const Infrastructure = () => {
  const [activeTab, setActiveTab] = useState("LIBRARY");

  // Filter images based on the active tab
  const filteredImages = images.filter((image) => image.category === activeTab);

  return (
    <>
      <Header />
      <div className="image-section">
        <img src={image1} alt="Gallery" className="department-image" />
        <div className="overlay-text">Infrastructure</div>
      </div>
      <div className="infrastructure-wrapper">
        <div className="tab-container">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="infrastructure-container">
          {filteredImages.length > 0 ? (
            filteredImages.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image.src} alt={image.heading} />
                <div className="image-heading">{image.heading}</div>
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center", gridColumn: "1 / -1" }}>
              No images available for this category.
            </p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Infrastructure;
